import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import QuizApp from "@/pages/QuizApp";
import DayPage from "@/pages/DayPage";
import CheckinPage from "@/pages/CheckinPage";
import ThankYouPage from "@/pages/ThankYouPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<QuizApp />} />
        <Route path="/giorno/:day" element={<DayPage />} />
        <Route path="/checkin/:day" element={<CheckinPage />} />
        <Route path="/grazie" element={<ThankYouPage />} />
      </Routes>
    </BrowserRouter>
  );
}
